var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator":_vm.separator,"separator-class":_vm.separatorIcon,"replace":_vm.replace}},[_vm._l((_vm.breadcrumbList),function(br,brInx){return [_c('el-breadcrumb-item',{key:br.text + brInx,attrs:{"to":br.path,"replace":br.replace}},[_vm._v(" "+_vm._s(br.text)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }